const Scores: { [k: string]: any } = {
  "Phishing": 0,
  "Crypto Jacking": 0,
  "DDoS": 0,
  "Living off the land": 0,
  "Data Exfiltration": 0,
  "App vulnerabilities": 0,
  "Ransomware": 0,
  "Domain Dominance": 0,
  "Incident Response": 0,
}
export default Scores;


